import React from 'react';
import { UitkSelect } from 'uitk-react-input';

export interface TimePickerInterface {
  label: string;
  icon: any;
  error?: string;
  onChange: any;
  value: any;
  placeholder: string;
  name: string;
}

export const TimePicker: React.FC<TimePickerInterface> = ({
  label,
  icon,
  error,
  onChange,
  value,
  name,
}) => {
  const quarterHours = ['00', '15', '30', '45'];
  const times = [];
  for (let i = 0; i < 24; i++) {
    for (let j = 0; j < 4; j++) {
      let hoursText = '';
      const hours = i > 12 ? i - 12 : i;
      const min = quarterHours[j];
      const meridian = i < 12 ? 'AM' : 'PM';
      hoursText = hours < 10 ? `0${hours}` : `${hours}`;
      times.push({ value: hoursText + min + meridian, text: hoursText + ':' + min + ' ' + meridian });
    }
  }

  const optionListItems = times.map((item, i) => {
    return (
      <option key={i} value={item.value}>
        {item.text}
      </option>
    );
  });

  return (
    <UitkSelect
      aria-label={label}
      icon={icon}
      invalid={error}
      label={label}
      onChange={(e) => onChange(e)}
      value={value}
      data-name={name}
    >
      {optionListItems}
    </UitkSelect>
  );
};
